const QUERIES = {
  USERS_LIST: 'users-list',
  ORDER_LIST: 'view-orders',
  BRAND_LIST: 'car-brand',
}

export {QUERIES}
